import React from 'react';

const Loader = () => {
  return (
    <div className='loadmore-wrapper loadmore-append '>
      <div className='spinner-overlay is-active'>
        <div className='spinner brand-bg brand-color'></div>
      </div>
    </div>
  );
};

export default Loader;
